<template>
  <div class="container mt-5">
    <router-link class="float-right" to="/">
      <i class="fas fa-chevron-left"></i> Regresar
    </router-link>

    <h2 class="text-light mb-3">
      <i class="fas fa-check"></i> Toma de Asistencia
    </h2>

    <div class="row mb-3">
      <div class="col-md-3">
        <button class="btn btn-success mb-2" @click="enableManual()">Registro con Escaner SOE <i class="ml-3 fas fa-id-card"></i>  </button>
      </div>
      <div class="col-md-3">
        <input ref="manualToken" @keyup.enter="takeManualAttendance()" v-model="manualToken" v-if="isManual" type="text" class="form-control" placeholder="mantenga seleccionado">
      </div>
    </div>


    <div class="row">
      <div class="col-md-7" style="background:rgba(0,0,0,0.5); padding:10px">
        <h4 class="text-light mb-2">Últimos Estudiantes Registrados</h4>
        <br />
        <ul>
          <li v-for="item in attendanceList" :key="item.id" class="mt-1">
            {{item.student.lastName}}, {{ item.student.name }}
            <span
              class="ml-2"
              :class="[item.marker=='t' ? 'text-danger' : '']"
            >
              <b>{{item.date}}</b>
            </span>

            <span
              v-if="item.event=='in'"
              class="ml-2"
              :class="[item.event=='in' ? 'text-primary' : '']"
            >
              <i>
                <span v-if="item.marker!='e'">entrada </span>
                <span v-if="item.marker=='e'" class="text-warning">excusa </span>
                <i v-if="item.marker=='t'" class="fas fa-hourglass-end text-danger"></i>
                <i v-if="item.marker=='e'" class="fas fa-ambulance text-warning"></i>
              </i>
            </span>
            <span
              v-if="item.event=='out'"
              class="ml-2"
              :class="[item.event=='out' ? 'text-danger' : '']"
            >
              <i>salida</i>
            </span>
          </li>
        </ul>
      </div>
      <div class="col-md-3">
        <img
          v-if="picture"
          :src="picture"
          alt="AtChecker"
          class="shadow mb-2"
          style="border:solid 5px rgba(255,255,255,0.8);"
          :style="{transform: rotation }"
        />
        <button class="btn btn-dark mt-5 btn-lg" @click="registerExcuse()">
          Registrar Excusa
          <i class="fas fa-ambulance ml-2"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    attendanceTaken: function(data) {
      this.showNewRegister(data);
    },

    rawToken: function(data) {
      console.log("raw token...", data)
    }, 
  },
  data() {
    return {
      attendanceList: [],
      picture: null,
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,
      // students: this.$store.state.students

      pic_height: this.$store.state.pic_height,
      pic_width: this.$store.state.pic_width,
      rotation: this.$store.state.rotation,

      isManual:false,
      manualToken:""
    };
  },
  mounted() {
    try {
      this.getLastRecords();
      // console.log("pic_height --->> ", this.pic_height)
      // console.log("pic_width --->> ", this.pic_width)
      // console.log("rotation --->> ", this.rotation)      
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    enableManual(){
      this.isManual=true
      setTimeout(() => {        
        this.$refs.manualToken.focus()
      }, 300);
    },
    takeManualAttendance(){
      console.log("tomando manual....")      
      let token = this.manualToken
      let data = {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({id: token})
      };        
      fetch(this.url + "takeattendance", data)
      this.manualToken=""
    },
    
    showNewRegister(data) {
      console.log(data)
      if (data.student.schoolId != this.schoolId) {
        return
      }
      this.picture = data.student.picture;
      this.attendanceList.unshift(data);
      if (this.attendanceList.length > 8) {
        this.attendanceList.pop();
      }
    },
    async getLastRecords() {
      let req = await fetch(this.url + "getlastrecords/" + this.schoolId);
      let list = await req.json();
      
      // console.table(list)
      list.forEach(item => {
        let date = new Date(item.date)
        let time = date.toTimeString().substring(0,5)
        console.log("pos la fecha dis que es.... ", time)
        let element = {
          picture: item.picture,
          date: date.toISOString().substr(0, 10) + " " + time,
          // date: item.date.substr(0, 10) + " " + item.date.substr(11, 8),
          event: item.event,
          marker: item.marker,
          student: { name: item.name, lastName: item.lastname }
        };
        this.attendanceList.push(element);
      });
      this.picture = this.attendanceList[0].picture;
    },
    async registerExcuse() {
      try {
        this.$prompt("Ingrese el Código del Estudiante")
          .then(text => {
            //console.log("el text... >>>> ", text)
            //let list = this.students;
            // let filter = list.filter(s => s.code.toLowerCase().trim() == text.toLowerCase().trim());
            // let token = filter[0].token || null;            
            let token = text.toLowerCase().trim()

            if (token) {
              let data = {
                method: "post",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: token, marker: "e", code:true })
              };
              console.log("antes del post.... 121")
              let req = fetch(this.url + "test", data);
              console.log("despues del  post.... 122")

              if (req.ok) {
                this.$alert("Se registró la excusa", "Registrado", "success");
              } else {
                throw "Ocurrió un error";
              }
            } else {
              this.$alert("No se encontró el código", "Dato No Ingresado");
            }
          })
          .catch(() => {});
      } catch (error) {
        this.$alert(error, "Error", "error");
      }
    }
  }
};
</script>

<style lang="css" scoped>
b {
  color: #ddd;
}
li {
  color: #ccc;
}
.rotate{transform: rotate(-90deg);}
</style>>
